import "./CGU.css";
import "../components/fonts.css";
import App_store from "../assets/app-store.png";
import Play_store from "../assets/playstore.png";
import Landing_header from "../components/Landing_header.js";

function CGV() {
  return (
    <>
      <Landing_header />
      <div className="Landing">
        <>
          <h1 className="title">Conditions Générales de Vente</h1>
          <p className="disc">
            VEUILLEZ LIRE LES TERMES ET CONDITIONS SUIVANTS DE L’UTILISATION
            SOIGNEUSEMENT AVANT D'UTILISER NOS APPLICATIONS. TOUS LES
            UTILISATEURS DE NOS APPLICATIONS MOBILE CONVIENNENT QUE L'ACCÈS ET
            L’UTILISATION DE NOS APPLICATIONS MOBILE SONT RÉGLEMENTÉS PAR CES
            TERMES ET CONDITIONS ET À TOUTE AUTRE LOI APPLICABLE.
          </p>
          <p className="title2">Propriété intellectuelle</p>
          <p className="disc">
            1.1. La structure générale du site et des applications Happer, ainsi
            que les textes, graphiques, images, sons et vidéos la composant,
            sont la propriété de l’éditeur ou de ses partenaires. Toute
            représentation et/ou reproduction et/ou exploitation partielle ou
            totale des contenus et services proposés par Happer, par quelque
            procédé que ce soit, sans l’autorisation préalable et par écrit est
            strictement interdite et serait susceptible de constituer une
            contrefaçon au sens des articles L335-2 et suivants du Code de la
            propriété intellectuelle.
          </p>
          <p className="disc">
            1.2. Aucune reproduction, même partielle prévue à l’article L.122-5
            du Code de la propriété intellectuelle, ne peut être faite de ce
            site ni des applications sans l’autorisation du directeur de
            publication.
          </p>
          <p className="disc">
            1.3. Tous les éléments de ce site et des applications Happer, y
            compris les documents téléchargeables, sont libres de droit. A
            l’exception de l’iconographie, la reproduction des pages de ce site
            est autorisée à la condition d’y mentionner la source. Elles ne
            peuvent être utilisées à des fins commerciales et publicitaires.
          </p>
          <p className="title2">
            Modification des conditions générales de ventes
          </p>
          <p className="disc">
            2.1 L'entreprise Woman and Luxury réserve de modifier les conditions
            générales de ventes du site et des applications Happer à tout moment
            et sans préavis afin de les adapter aux potentielles évolutions du
            site et des applications.
          </p>
          <p className="disc">
            2.2 Les utilisateurs seront prévenus par une alerte de mise à jour
            des conditions générales de ventes.
          </p>
          <p className="title2">Paiement</p>
          <p className="disc">
            7.1 Le paiement des produits en vente sur Happer et proposés par nos
            influenceurs peuvent être effectué par carte bancaire, Apple Pay ou
            Google Pay ou autres méthodes qui peuvent être rendues disponibles
            sur nos applications mobiles.
          </p>
          <p className="disc">
            7.2 Le paiement sera débité et dégagé de votre compte à la période
            de l’achat des produits. Vous convenez également que vous pouvez
            être sujette à des contrôles de validation de votre carte de crédit
            avec l’émetteur de carte depuis le site de nos partenaires.
          </p>
          <p className="disc">
            7.3 Le client peut passer commande sur l'application Happer en
            sélectionnant les produits qu'il souhaite acheter. Le client doit
            s'assurer que les informations fournies pour la commande et le
            paiement sont exactes et complètes.
          </p>
          <p className="title2">Livraison</p>
          <p className="disc">
            8.0 Les produits sont livrés à l'adresse indiquée par le client lors
            de la commande. Les frais de livraison sont à la charge du client.
            Les délais de livraison sont indiqués sur l'application Happer et
            peuvent varier en fonction de la disponibilité des produits.
          </p>
          <p className="disc">
            8.1 La livraison est dépendante de nos partenaires et envoyée à
            votre domicile.
          </p>
          <p className="disc">
            8.2 La livraison sera assurée par nos partenaires dans les délais
            accordés par eux-mêmes. Cependant les problèmes d’approvisionnement
            ou une demande inattendue peuvent de temps en temps avoir comme
            conséquence des retards.Si jamais il y a un retard, nous vous
            contacterons au plus tôt pour vous informer de la raison du retard.
            Nous ne sommes responsables d’aucun retard qui peut être causé par
            la livraison des produits.
          </p>
          <p className="title2">Retours et échanges</p>
          <p className="disc">
            9.0 Toute demande de retour, échange ou remboursement se fait par
            demande email à{" "}
            <a href="mailto:contact@happer.fr">contact@happer.fr</a>. Le client
            dispose d'un délai de 14 jours pour retourner les produits qui ne
            lui conviennent pas, à condition qu'ils soient en parfait état et
            dans leur emballage d'origine. Happer procédera au remboursement des
            produits retournés dans les meilleurs délais.
          </p>
          <p className="disc">
            9.1 Si vous souhaitez renvoyer des produits que vous achetez ou
            gagnez sur nos applications, nous vous invitons à prendre contact
            avec happer depuis nos applications.
          </p>
          <p className="disc">
            9.2 Les retours seront acceptés selon les modalités de nos
            partenaires.
          </p>
          <p className="disc">
            9.3 Le ou les produits devront être rendus dans leurs états
            d’origine, c'est-à-dire inutilisés avec toutes les étiquettes de
            vêtement jointes.
          </p>
          <p className="disc">
            9.4 Les articles endommagés ou souillés qui sont renvoyés à nos
            partenaires ne seront pas acceptés et seront renvoyés au client.
          </p>
          <p className="title2">Produits</p>
          <p className="disc">
            10.1 Nous attestons que les marchandises seront conformes aux
            descriptions données sur les applications mobiles.
          </p>
          <p className="disc">
            10.2 Tous les produits sont neufs et authentiques.
          </p>
          <p className="title2">Aucune utilisation commerciale</p>
          <p className="disc">
            Ces applications mobiles ne peuvent être utilisées commercialement.
            Vous ne pouvez ni copier ni distribuer ou commercialement exploiter
            le matériel sans accord écrit des dirigeants des applications
            mobiles.
          </p>
          <p className="title2">Votre activité</p>
          <p className="disc">
            13.1 Vous convenez que vous serez personnellement responsable des
            achats que vous ferez sur ces applications et de votre communication
            sur nos applications . Si nous déterminons que vous êtes ou avez été
            engagés dans des activités interdites, n’étaient pas respectueux
            d’autres utilisateurs, ou ont autrement violé les termes et
            conditions, nous pouvons vous refuser l’accès à nos applications
            mobiles sur une base provisoire ou permanente.
          </p>
          <p className="disc">
            13.2 N’importe quel abus ou violation d’un compte utilisateur aura
            comme conséquence la disqualification de l’utilisateur et peut
            également avoir comme conséquence les poursuites pénales.
          </p>
          <p className="disc">
            13.3 Nous ne tolérons pas de quelque façon l’activité inadéquate et
            frauduleuse, et chercherons des sanctions criminelles et
            contractuelles contre toute personne impliquée dedans ou suspectée
            de la participation dans la fraude, la malhonnêteté ou les actes
            criminels, ou la connivence, ou la connivence suspectée avec
            d’autres personnes impliquées dans la fraude, la malhonnêteté ou les
            actes criminels.
          </p>
          <p className="title2">Arrêt des applications Happer</p>
          <p className="disc">
            Happer se réserve le droit de fermeture ou de suspension des
            applications mobiles pour des raisons quelconque.
          </p>
          <p className="title2">Litige</p>
          <p className="disc">
            Tant les présentes applications mobiles que les modalités et
            conditions de son utilisation sont régies par le droit français,
            quel que soit le lieu d’utilisation. En cas de contestation
            éventuelle, et après l’échec de toute tentative de recherche d’une
            solution amiable, les tribunaux français seront seuls compétents
            pour résoudre le litige.
          </p>
        </>
      </div>
    </>
  );
}

export default CGV;
